/**
 * FilterChips Component
 *
 * Displays active filters as removable chips.
 */

import React from 'react';
import { X } from 'lucide-react';
import { FilterChipsProps } from './types';

export function FilterChips({
  activeFilters,
  onRemove,
  onClearAll,
  className = '',
}: FilterChipsProps) {
  if (activeFilters.length === 0) return null;

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <span className="text-xs text-gray-500 font-medium">Active filters:</span>
      {activeFilters.map((filter) => (
        <span
          key={filter.key}
          className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-purple-100 text-purple-800 text-xs font-medium rounded-full"
        >
          <span className="text-purple-600">{filter.label}:</span>
          <span className="max-w-[150px] truncate">{filter.displayValue}</span>
          <button
            type="button"
            onClick={() => onRemove(filter.key)}
            className="ml-0.5 p-0.5 hover:bg-purple-200 rounded-full transition-colors"
            aria-label={`Remove ${filter.label} filter`}
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      {onClearAll && activeFilters.length > 1 && (
        <button
          type="button"
          onClick={onClearAll}
          className="text-xs text-gray-500 hover:text-gray-700 underline ml-1"
        >
          Clear all
        </button>
      )}
    </div>
  );
}

export default FilterChips;
